// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"6478f036","476":"d6242d69","657":"b6ee2e13","974":"71056240"}[chunkId] + ".chunk.css";
};